import React, { useState, useEffect } from 'react';
import SurveySection from '../SurveySection';
import { Tooltip } from 'react-tippy';
import InProcessMandateRow from './InProcessMandateRow.jsx';
import { observer } from 'mobx-react';
import ibsStore from '../Stores/IbsSurveyStore';
import { InProcessMandateMultiActionModal } from './Modals/InProcessMandateMultiActionModal';
import { MandateStatus } from './MandateStatus.ts';
import { isValidTemplateRow } from '../../helpers';
import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCaretUp, faCaretDown, faSquare, faCheckSquare } from '@fortawesome/free-solid-svg-icons';
import { sortObjects } from '../../helpers';
library.add(faCaretUp);
library.add(faCaretDown);

export const InProcessMandatesTable = observer((props) => {
    let {
        columns,
        downloadFile,
    } = props;

    let [multiActionModalSettings, setMultiActionModalSettings] = useState({show: false, mode: ''});
    let [mandates, _setMandates] = useState(ibsStore.templateInProcess);
    let [sortConfig, setSortConfig] = React.useState(null);

    const requestSort = (column) => {
        const colId = column.id;
        const colDataType = column.dataType;

        let direction = 'ascending';
        if (sortConfig && sortConfig.key === colId && sortConfig.direction === 'ascending') {
            direction = 'descending';
        }

        setSortConfig({ key: colId, direction: direction, dataType: colDataType });
    }

    useEffect(() => {
        setMandates(ibsStore.templateInProcess);
    }, [ibsStore.templateInProcess])

    const setMandates = (updatedArr) => {
        _setMandates(updatedArr);
        ibsStore.templateInProcess = updatedArr;
    }

    const updateRow = (updatedRow) => {
        let allMandates = ibsStore.templateInProcess;
        let targetMandateIndex = allMandates.findIndex(template => template.rowId === updatedRow.rowId);
        if(targetMandateIndex >= 0) {
            allMandates[targetMandateIndex] = { ...allMandates[targetMandateIndex], ...updatedRow }
            setMandates(allMandates)    
        }
    }

    const selectRow = (row) => {
        let curInProcess = ibsStore.templateInProcess;
        let curRow = curInProcess.find(inProcessRow => inProcessRow.rowId === row.rowId);
        curRow.isSelected = !curRow.isSelected;
        setMandates(curInProcess);
    }

    const selectAllRows = () => {
        let curInProcess = ibsStore.templateInProcess;
        let selectedInProcessRows = curInProcess.filter(template => template.isSelected);
        if (selectedInProcessRows.length > 0) {
            curInProcess = curInProcess.map(template => ({ ...template, 'isSelected': false }));
        } else {
            curInProcess = curInProcess.map(template => ({ ...template, 'isSelected': true }))
        }
        setMandates(curInProcess);
    }

    let rowCount = ibsStore.templateInProcess ? ibsStore.templateInProcess.length : 0;

    return <SurveySection>
        <section className="generalModal">
            <InProcessMandateMultiActionModal
                multiActionModalSettings={multiActionModalSettings}
                setMultiActionModalSettings={setMultiActionModalSettings}
                mandates={mandates}/>
        </section>

        <div className="titleRow">
            <h3 className="sectionTitle">In process: {rowCount}</h3>
            <div className="allActionsButtons">
                <input type="button"
                       className={mandates.filter(mandate => mandate.isSelected).length > 0 ? 'addRow' : 'disabledRow'}
                       style={{width: "auto", paddingLeft: "3px", paddingRight: "3px"}}
                       value='Continue' onClick={() => setMultiActionModalSettings({show: true, mode: 'add'})}/>
                <input type="button"
                       className={mandates.filter(mandate => mandate.isSelected).length > 0 ? 'removeRow' : 'disabledRow'}
                       style={{width: "auto", paddingLeft: "3px", paddingRight: "3px"}}
                       value='Remove' onClick={() => setMultiActionModalSettings({show: true, mode: 'remove'})}/>

                <button className="selectAll addRow"
                        style={{paddingLeft: "1px"}}
                        onClick={() => selectAllRows()} >
                    <FontAwesomeIcon icon={mandates.every(mandate => mandate.isSelected) ? faCheckSquare : faSquare}/>
                </button>
            </div>
        </div>
        <hr style={{width: '100%', margin: '0px 0px 10px 0px'}}/>

        <table className="UserAction">
            <colgroup>
            {columns
                    .filter(columns => columns.hidden !== true)
                    .map(column => <col span="1" style={{width: `${column.width}%`}}/>)
                }
            </colgroup>
            <thead>
            <tr>
                {columns
                    .filter(columns => columns.hidden !== true)
                    .map((column, columnIdx) => {
                        let text = (column.title);
                        let classList = [];
                        if (column.filterable) {
                            classList.push('clickable');
                            text = <>
                                {text}
                                <span style={{float: 'right', marginRight: '0.5rem'}}>
                                    <i className="fas fa-filter"></i>
                                </span>
                            </>;
                        }
                        if (sortConfig?.key) {
                            if (sortConfig.key === column.id) {
                                text = <>
                                    {text}
                                    {sortConfig.direction === 'ascending' 
                                        ? (<FontAwesomeIcon className='fa-caret' icon='caret-up'/>)
                                        : (<FontAwesomeIcon className='fa-caret' icon='caret-down'/>)}
                                </>
                            }
                        }
                        if (column.tooltip) {
                            text = <>
                                {text}
                                <Tooltip
                                    position={columnIdx < 2 ? "right" : columnIdx > columns.length - 2 ? "left" : "bottom"}
                                    trigger="mouseenter"
                                    animation="fade"
                                    arrow="true"
                                    size="small"
                                    interactive="true"
                                    hideOnClick="false"
                                    html={(column.tooltip)}
                                    popperOptions={{
                                        modifiers: {
                                            preventOverflow: {
                                                enabled: false,
                                            },
                                            flip: {
                                                enabled: false,
                                            },
                                        },
                                    }}
                                >
                                    <i className="fas fa-info-circle fa-xs"></i>
                                </Tooltip>
                            </>
                        }

                        if (column.centered) classList.push('centerCell');

                        return (<th
                            className={classList.join(' ')}
                            onClick={() => column.filterable ? requestSort(column) : null}
                        >{text}</th>)
                    })}
            </tr>
            </thead>
            <tbody>
            {mandates ? mandates
                .sort((a, b) => {
                    if (sortConfig?.key) {
                        return sortObjects(a, b, sortConfig.key, sortConfig.dataType, sortConfig.direction);
                    } else {
                        return 0;
                    }
                })
                .map(row => <InProcessMandateRow
                    agrId={row.agrId}
                    analystComments={row.analystComments}
                    asset={row.asset}
                    assetClassId={row.assetClassId}
                    dateAdded={row.dateAdded}
                    filePath={row.filePath}
                    fundName={row.fundName}
                    isLgpsPoolOption={row.isLgpsPoolOption}
                    managerName={row.managerName}
                    mandateId={row.mandateId}
                    newRow={row.newRow}
                    rowId={row.rowId}
                    statsInfo={row.statsInfo}
                    status={row.status}
                    statusId={row.statusId}
                    style={row.style}
                    styleId={row.styleId}
                    templateType={row.templateType}
                    updateRow={updateRow}
                    isSelected={row.isSelected}
                    setCheckedRows={selectRow}
                    downloadFile={downloadFile}
                    managerId={row.managerId}
                    normalizedManagerName={row.normalizedManagerName}
                />) : null}
            </tbody>
        </table>
    </SurveySection>
});